import KPICard from "./KPICard";

export default KPICard;
